import { connect } from 'react-redux';
import CsvForm from '../../../components/navigation/csv/CsvForm';
import { getEvents, getEventsCsv, getEventsGroupColumn } from '../../../reducers/analyticsApp';
import { getTypeField } from '../../../utils/event/createQueries';
import { fieldTypes } from '../../../constants/metainf';
import { aggregationTypes } from '../../../constants/event';
import { setEventCsvColumn } from '../../../actions/events/csvEvents';

const mapStateToProps = (state) => ({
  csvState: getEventsCsv(state),
  isDateGroupBy:
    getEventsGroupColumn(state) &&
    [fieldTypes.TIME, fieldTypes.COHORT].includes(
      getTypeField(getEventsGroupColumn(state), state).type
    ),
  isDateSplitBy: getEvents(state).some(
    ({ splitColumn }) =>
      splitColumn &&
      [fieldTypes.TIME, fieldTypes.COHORT].includes(getTypeField(splitColumn, state).type)
  ),
  isSplit: getEvents(state).some(
    ({ splitColumn }) =>
      splitColumn &&
      ![fieldTypes.TIME, fieldTypes.COHORT].includes(getTypeField(splitColumn, state).type)
  ),
  isTotal: !!getEvents(state).find(({ aggregationColumn }) => aggregationColumn),
  isAvg: !!getEvents(state).find(
    ({ aggregationColumn, aggregationType }) =>
      aggregationColumn && aggregationType === aggregationTypes.SUM
  ),
  isShowPeriods: getEvents(state).some(({ periodsState }) => !!periodsState.periods[0]?.from),
});

const mapDispatchToProps = (dispatch) => ({
  changeState: (e) =>
    dispatch(
      setEventCsvColumn({
        [e.target.nameCheckbox]: e.target.checked,
      })
    ),
  dispatch,
});

export default connect(mapStateToProps, mapDispatchToProps)(CsvForm);
